import { useObserver } from 'mobx-react';
import useMst from '~/src/hooks/useMst';
import useResourcePagination from '~/src/hooks/useResourcePagination';
import SortByOrder from '~/src/hooks/sortByOrder';

const useTemplateDefaultValuesPagination = () => {
  const { templateDefaultValues } = useMst((store) => ({
    templateDefaultValues: store.templateDefaultValues,
  }));

  const { loading, next, page, empty, setSearch, done, setSortBy, setOrder } =
    useResourcePagination({
      fetch: templateDefaultValues.getTemplateDefaultValuesList,
      limit: 10,
      order: SortByOrder.desc,
    });

  const listData = useObserver(() => {
    return templateDefaultValues.list.flat();
  });

  return {
    next,
    page,
    empty,
    data: listData,
    loading,
    done,

    setSearch,
    setSortBy,
    setOrder,
  };
};

export default useTemplateDefaultValuesPagination;
